// This icon file is generated automatically.
var LogoutSquareOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 200 200", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M141.42 135.36a5.27 5.27 0 005.3 5.3c1.4 0 2.74-.56 3.74-1.56l35.44-35.43a5.29 5.29 0 00-.01-7.48l-35.31-35.3c-2-2-5.5-2-7.5 0a5.28 5.28 0 000 7.5l26.26 26.25H83.61a5.3 5.3 0 000 10.6h85.74l-26.38 26.37c-1 1-1.56 2.34-1.55 3.75zm37.54-122.8H21.04a8.49 8.49 0 00-8.48 8.48v157.93c0 4.67 3.8 8.47 8.48 8.47h157.92c4.68 0 8.48-3.8 8.48-8.47v-25.7a5.3 5.3 0 00-10.6 0v23.57H23.16V23.16h153.68v23.57a5.3 5.3 0 0010.6 0v-25.7c0-4.67-3.8-8.47-8.48-8.47z" } }] }, "name": "logout-square", "theme": "outlined" };
export default LogoutSquareOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/LogoutSquareOutlined.js
// module id = 3079
// module chunks = 0